import React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import Home from './components/Home';
import Hospitals from './components/Hospitals/Hospitals';
import GroupReports from './components/GroupReports/GroupReports';
import Login from './components/Login/Login';
import Logout from './components/Login/Logout';
import ResetPassword from './components/Login/ResetPassword';
import ForgotPassword from './components/Login/ForgotPassword';
import Lookup from './components/Admin/Lookup';
import Users from './components/Admin/Users';
import AffiliateGroups from './components/ManageGroups/AffiliateGroups';
import GpoGroups from './components/ManageGroups/GpoGroups';
import ExternalAccessReport from './components/ExternalAccessReport';
import Mappings from './components/Mappings/Mappings';

import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

//import 'react-bootstrap-typeahead/css/Typeahead.css';

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import theme from './theme';

export default () => {
    // #/report is not a valid route in our app, but it does indicate an
    // external unsecure (but allowed) request to render a report (i.e. from Igloo)
    if (window.location.hash.includes('#/report/')) {
        return <ExternalAccessReport />;
    }

    return (
        <MuiThemeProvider theme={theme}>
            <Layout>
                <Route exact path='/' component={Home} />
                <Route exact path='/login' component={Login} />
                <Route path='/logout' component={Logout} />
                <Route path='/resetpassword' component={ResetPassword} />
                <Route path='/forgotpassword' component={ForgotPassword} />
                <Route path='/hospitals' component={Hospitals} />
                <Route path='/groupreports' component={GroupReports} />
                <Route path='/mappings/mappings' component={Mappings} />
                <Route path='/manage/affiliates' render={(props) => <Lookup {...props} lookupName='Affiliates' />} />
                <Route path='/manage/codegroups' render={(props) => <Lookup {...props} lookupName='Code Groups' />} />
                <Route path='/manage/revenuecategories' render={(props) => <Lookup {...props} lookupName='Revenue Categories' />} />
                <Route path='/manage/servicelevels' render={(props) => <Lookup {...props} lookupName='Service Levels' />} />
                <Route path='/manage/contactroles' render={(props) => <Lookup {...props} lookupName='Contact Roles' />} />
                <Route path='/manage/manufacturers' render={(props) => <Lookup {...props} lookupName='Manufacturers' />} />
                <Route path='/manage/unitsofmeasure' render={(props) => <Lookup {...props} lookupName='Units of Measure' />} />
                <Route path='/manage/users' component={Users} />
                <Route path='/managegroups/affiliategroups' component={AffiliateGroups} />
                <Route path='/managegroups/gpogroups' component={GpoGroups} />
            </Layout>
        </MuiThemeProvider>
    );
};



// WEBPACK FOOTER //
// ./src/App.js